<div class="content-side">
    <div class="row">
        <div class="col-2-of-2">
            <app-column-header [headerData]="headerData" (topbtnaction)="openModal(0)"></app-column-header>
            <div class="commonBlock">
                <!-- <ag-grid-angular [pagination]="true" #agGrid [gridOptions]="gridOptions"
                    (gridReady)="onGridReady($event)" [paginationAutoPageSize]=true style="width: 100%; height: 450px;"
                    class="ag-theme-balham">
                </ag-grid-angular> -->
                <app-primeng-grid [columnConfig]="columnDefPrimeNG" [data]="dataGridPrimeNG" [gridConfig]="gridConfigPrimeNG" style="width: 100%; height: 450px;" (cellClicked)="viewDashboard($event)" [isCustomer]="true">
                    <ng-template primengTemplate="buttonRenderer" let-row let-col="col" let-rowIndex="rowIndex">
                        <app-button-renderer [params]="buildParams(row,col,rowIndex)">
                        </app-button-renderer>
                    </ng-template>
                </app-primeng-grid>
            </div>
        </div>
    </div>
</div>